import React from 'react'
import { TimeRangeInput } from './TimeRangeInput'

const DEFAULT_OPEN  = '09:00'
const DEFAULT_CLOSE = '17:00'

function HolidayRow({ holiday, onChange }) {
  const active = !!holiday.active
  const closed = !!holiday.closed

  function handleClosedToggle(checked) {
    onChange(
      holiday.name,
      checked
        ? { closed: true,  opens_at: null,         closes_at: null }
        : { closed: false, opens_at: DEFAULT_OPEN, closes_at: DEFAULT_CLOSE }
    )
  }

  return (
    <tr>
      <td style={{ verticalAlign: 'middle' }}>
        <input
          type="checkbox"
          checked={active}
          onChange={(e) => onChange(holiday.name, { active: e.target.checked })}
        />
      </td>
      <td style={{ verticalAlign: 'middle' }}>
        <div className="dome-d-flex dome-flex-column">
          <span className="dome-p2 dome-color-darkest-grey">{holiday.label || holiday.name}</span>
          <span className="dome-p4 dome-color-med-grey">{holiday.date}</span>
        </div>
      </td>
      <td style={{ verticalAlign: 'middle' }}>
        {active && (
          <input
            type="checkbox"
            checked={closed}
            onChange={(e) => handleClosedToggle(e.target.checked)}
          />
        )}
      </td>
      <td style={{ verticalAlign: 'middle' }}>
        {active && !closed && (
          <TimeRangeInput
            open={holiday.opens_at || ''}
            close={holiday.closes_at || ''}
            onChange={({ open, close }) => onChange(holiday.name, { opens_at: open, closes_at: close })}
          />
        )}
        {active && closed && <span className="dome-p2 dome-color-med-grey">closed</span>}
      </td>
    </tr>
  )
}

export function HolidayListEditor({ title, subTitle, holidays, onChange, onSave, error, dirty = true }) {
  return (
    <div>
      <h4 className="dome-color-darkest-grey" style={{ marginBottom: 12 }}>
        {title}
      </h4>
      <p className="dome-p2 dome-color-med-grey" style={{ marginBottom: 16 }}>
        {subTitle}
      </p>
      <table className="table table-condensed table-hover">
        <thead>
          <tr>
            <th style={{ width: 40 }}>On</th>
            <th>Holiday</th>
            <th style={{ width: 80 }}>Closed</th>
            <th style={{ width: 300 }}>Hours</th>
          </tr>
        </thead>
        <tbody>
          {holidays.map((h) => (
            <HolidayRow key={h.key} holiday={h} onChange={onChange} />
          ))}
        </tbody>
      </table>
      <div className="dome-d-flex dome-align-center dome-gap6">
        <button
          type="button"
          className={`dome-btn dome-btn-base ${dirty ? 'dome-btn-green-stroke' : 'dome-btn-disabled'}`}
          onClick={onSave}
          disabled={!dirty}
        >
          Save
        </button>
        {error && <span className="text-danger dome-p3">{error}</span>}
      </div>
    </div>
  )
}
